module.exports = __webpack_public_path__ + "img/ry-3.82b0813c.png";